<template>
    <div v-if="loaded">
        <nav class="navbar navbar-expand-lg navbar-fixed-top navbar-light navbar-crm">
            <div class="navbar-crm__title">
                <a href=""><img src="../../static/images/mydr-logo.png" alt="logo" /></a>
            </div>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav-menu" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="nav-menu">

                <div class="navbar-collapse">
                    <ul class="navbar-nav mr-auto">
                        <template v-if="activeTabs.length > 1 || activeDropdownTabs.length > 0">
                            <li class="nav-item" v-for="tab in activeTabs" :key="tab.name" @click="currentTab = tab"
                                :class="{ active: currentTab === tab }">
                                <a class="nav-link" href="#">{{ tab.name }}</a>
                            </li>
                        </template>
                    </ul>
                    <div class="mx-auto order-0"></div>
                    <ul class="nav navbar-nav navbar-right">
                        <NavbarDropdown
                                :currentApp="currentApp"
                                :activeDropdownTabs="activeDropdownTabs"
                                @click="(t) => { currentTab = t }"
                                @logout="logout()"
                        />
                    </ul>
                </div>
            </div>
        </nav>
        <transition name="component-fade" mode="out-in">
            <component :class="currentTab.classes" :is="currentTab.component" class="my-3"></component>
        </transition>
    </div>
</template>

<script>
    import Login from './Login.vue';
    import NavbarDropdown from './NavbarDropdown.vue';
    import Constants from '../constants.js';
    import '../../node_modules/bootstrap/dist/js/bootstrap.min.js';

    export default {
        name: "Navbar",
        components: {
            Login,
            NavbarDropdown,
        },
        props: {
            tabs: {                // [{ name, component, classes, showIf, [defaultTab] }] ; showIf is a callback function
                type: Array,
                required: false,
            },
            dropdownTabs: {        // [{ name, component/href, classes, showIf, [defaultTab] }] ; showIf is a callback function
                type: Array,       // depending on purpose, put component or href exclusively (if using href, don't use
                required: false,   // defaultTab optional argument)
            },
            currentApp: {
                type: String,
                required: true,
                validator: value => Constants.get('APP_NAMES').indexOf(value) >= 0,
            }
        },
        data: function () {
            return {
                chosenTab: null,
                loaded: false,
                blankComponent: {
                    template: '<div></div>'
                },
                loginComponent: {
                    name: 'Login',
                    component: Login,
                },
            }
        },
        watch: {
            authenticated(authenticated) {
                const thisApp = this.$store.getters['auth/apps'].find(e => e.name === this.currentApp);
                if (authenticated && !thisApp.authorized) {
                    this.$vs.notify({text: 'Nie masz uprawnień, żeby wejść na tę stronę.', color: 'danger'});
                    this.logout();
                }
                if (authenticated && thisApp.authorized && thisApp.isAdmin) {
                    window.location.replace('/admin');
                }
            }
        },
        computed: {
            authenticated() {
                this.currentTab = this.blankComponent;  // to force Vue to redirect to default tab after login/logout
                return this.$store.getters['auth/authenticated'];
            },
            username() {
                return this.$store.getters['auth/username'];
            },
            activeTabs() {
                return this.tabs ? this.tabs.filter(this.showFilter) : [];
            },
            activeDropdownTabs() {
                return this.dropdownTabs ? this.dropdownTabs.filter(this.showFilter) : [];
            },
            currentTab: {
                get() {
                    let isChosenTab = (el) => {
                        return this.chosenTab === el;
                    };

                    let findDefault = function (el) {
                        return (typeof el.defaultTab !== 'undefined') && el.defaultTab;
                    };

                    if (!this.activeTabs.find(isChosenTab) && !this.activeDropdownTabs.find(isChosenTab)) {
                        this.chosenTab = this.activeTabs.find(findDefault) ||
                            this.activeDropdownTabs.find(findDefault) ||
                            this.loginComponent;
                    }

                    return this.chosenTab;
                },
                set(val) {
                    this.chosenTab = val;
                }
            }
        },
        created() {
            this.currentTab = this.blankComponent;
            this.$store.dispatch('auth/getAuthentication')
                .then(() => {
                    this.loaded = true;
                })
                .catch(() => {
                    this.$vs.notify({text: 'Nie udało się pobrać danych z serwera.', color: 'danger'});
                });
        },
        methods: {
            logout() {
                this.$store.dispatch('auth/logout');
            },
            showFilter(el) {
                return (typeof el.showIf !== 'undefined') && el.showIf();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }

    .component-fade-enter, .component-fade-leave-to {
        opacity: 0;
    }
    .navbar-crm {
        background: #e9e9e9;
        background: -moz-linear-gradient(top, #e9e9e9 0%, #ddd 100%);
        /* FF3.6-15 */
        background: -webkit-linear-gradient(top, #e9e9e9 0%, #ddd 100%);
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, #e9e9e9 0%, #ddd 100%);
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        border-bottom: 1px solid #ddd;

        &__title {
            margin-right: 2rem;
        }
    }

    .navbar-light .navbar-nav .show>.nav-link,
    .navbar-light .navbar-nav .active>.nav-link,
    .navbar-light .navbar-nav .nav-link.show,
    .navbar-light .navbar-nav .nav-link.active {
        color: #ff6200;
    }
</style>


// WEBPACK FOOTER //
// Navbar.vue?4f34fbc9